<template>
  <div class="mx-2">
    <div class="row gy-2">
      <strong class="mb-2 mt-3">Leyenda:</strong>
      <p class="my-0 py-0">
        <button class="btn btn-primary p-1 me-1 my-2"></button>Habilitado
      </p>
      <p class="my-0 py-0">
        <button class="btn btn-dark p-1 me-1 my-2"></button>Deshabilitado
      </p>
    </div>

        <!-- Tab 1: Acceso por Sede (Contenido Original) -->
          <button @click="mostrarIconos = !mostrarIconos" class="btn btn-success ms-5 mb-4 mt-3">
            Añadir Video
          </button>

          <div v-if="mostrarIconos" class="row gx-1 gy-1 mx-5">
            <div class="col col-1" v-for="arrayIcono in arrayIconos" :key="arrayIcono.id">
              <i class="d-inline" @click="idIconito = arrayIcono.idIcono" :class="[
                arrayIcono.nomIcono,
                { 'bg-primary fs-5 text-white': idIconito === arrayIcono.idIcono },
              ]"></i>
            </div>
          </div>

          <div v-if="mostrarIconos" class="mx-5">
            <h6 class="mt-5">Nombre Video:</h6>
            <input v-model="nombreVideo" type="text" class="form-control" placeholder="Nombre de Video" />
          </div>

          <div v-if="mostrarIconos" class="mx-5">
            <h6 class="mt-3">Link Video:</h6>
            <input v-model="linkVideo" type="text" class="form-control mt-2" placeholder="Link Video" />
          </div>

          <div v-if="mostrarIconos" class="mt-3 ms-5">
            <button @click="GuardarNuevoVideo" class="btn btn-primary">
              Guardar
            </button>
          </div>

          <div v-if="mostrar" class="tamaño d-flex">
            <div class="ms-4 mt-2 d-flex" v-for="(items) in listadoDeVideos" :key="items.idCabVideo">
              <input class="me-2" type="checkbox" :value="items.idCabVideo"
                :checked="apiVideosAccesos.some((video) => video.idCabVideo === items.idCabVideo)"
                @change="ParametrosVideo(items, $event.target.checked)" />
              <span :class="{
                'text-danger': apiVideosAccesos.some(
                  (video) => video.idCabVideo === items.idCabVideo
                ),
              }">
                <i class="fs-2" :class="items.icono" :title="items.nombre"></i>
              </span>
            </div>
          </div>

          <div class="row gx-1 mt-3">
            <div class="col col-3 mt-2">
              <div class="d-flex mt-1 ms-3 align-items-center border border-3 rounded cursor highlight-on-click"
                v-for="empresas in empresa" :key="empresas.id" :class="{ 'selected': empresaValor == empresas.id }">
                <div class="mx-2 w-100 text-start" @click="CentroCostos(empresas.id, selectedCentroCosto = [], selectedSubCentroCosto = [],
                  centroCostosValor = '', subCentroValor = ''
                )">
                  <p class="tamaño my-0 d-flex align-items-center">
                    {{ empresas.empNomCorto }}
                  </p>
                </div>
              </div>
            </div>

            <div class="col col-4">
              <div class="d-flex mt-2 align-items-center border border-3 rounded cursor" v-for="centros in CentroDeCosto"
                :key="centros.id" :class="{ 'selected': centroCostosValor == centros.idCentro }">
                <div class="mx-2 w-100 text-start" @click="SubCentroCostos(centros.idCentro, centros.cenCodigo)">
                  <p class="tamaño my-0 d-flex align-items-center">
                    {{ centros.cenNombre }}
                  </p>
                </div>
              </div>
            </div>

            <div class="col col-4">
              <div class="d-flex mt-2 align-items-center border border-3 rounded cursor"
                v-for="subCentro in subCentroDeCostos" :key="subCentro.id" :class="{
                  'selected': subCentroValor == subCentro.id
                }">
                <div class="mx-1 w-100 text-start" @click="SubSubCentroCostos(subCentro.id, subCentro.cenSubCentro)">
                  <p class="tamaño my-0 d-flex align-items-center">
                    {{ subCentro.cenNombre }}
                  </p>
                </div>
              </div>
            </div>
          </div>
       
  </div>
</template>

<script>
import Swal from "sweetalert2";
export default {
  name: "SolimanoLogAccesoCapacitacion",

  data() {
    return {
      idEmpresa: "",
      empresa: [],
      CentroDeCosto: [],
      subCentroDeCostos: [],
      subSubCentroDeCostos: [],
      empresaValor: "",
      subCentroValor:"",
      dniUsuarios: "",
      codSubCentroCosto: "",

      listadoDeVideos: [],
      idVideo: "",
      checkedVideo: null, // ID del video seleccionado

      array: [],
      arrayCentro: [],
      arraySubCentro: [],

      selectedEmpresas: [], // Array para mantener los IDs de las empresas seleccionadas
      selectedCentroCosto: [],

      selectedSubCentroCosto: [],

      videosSeleccionados: [],

      apiVideosAccesos: [],

      mostrar: false,

      arrayIconos: [],
      mostrarIconos: false,
      nombreVideo: "",
      linkVideo: "",
      idIconito: "",
      centroCostosValor:"",
    };
  },

  mounted() {
  

    this.axios.get(`BIClientes/ListadoIconos`).then((r) => {
      this.arrayIconos = r.data;
      console.log(r.data);
    });

    this.ListasDeLosVideos();
  },

  created() {
    this.dniUsuarios = localStorage.getItem("dniUsers");
    this.cambiarEstadoNavbar();
    this.getAttributes();
  },

  methods: {
    cambiarEstadoNavbar() {
      // Acción directa para cambiar el estado del navbar a true
      this.$store.dispatch("acciones/CambioNavbar", true);
    },

    ListasDeLosVideos(){
        this.axios.get(`VidCapacitacion/ListadoVideos`).then((r) => {
      console.log(r.data);
      this.listadoDeVideos = r.data;
    });
    },

   

    GuardarNuevoVideo() {
      const from = {
        idIcono: `${this.idIconito}`,
        nombre: `${this.nombreVideo}`,
        linkVid: `${this.linkVideo}`,
      };

      console.log(from);
      this.axios.post(`VidCapacitacion/InsertarVideo`, from).then((r) => {
        console.log(r.data);
        if (r.data) {
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Se registró cambios",
            showConfirmButton: false,
            timer: 1500,
          });
          this.idIconito = "";
          this.nombreVideo = "";
          this.linkVideo = "";
        }
      });
    },

    ParametrosVideo(items, valor) {
      console.log(items.idCabVideo, valor);

      if (!valor) {
        this.axios
          .delete(
            `VidCapacitacion/EliminarVideoxCuenta?idEmpresa=${this.idEmpresa}&idVideo=${items.idCabVideo}&SolCc=${this.codCentroCosto}&SolScc=${this.codSubCentroCosto}`
          )
          .then((r) => {
            console.log(r.data);
            Swal.fire({
              position: "center",
              icon: "success",
              title: `${r.data}`,
              showConfirmButton: false,
              timer: 1500,
            });

            this.listaVideos();
          });
      } else {
        const from = {
          idCabVideos: `${items.idCabVideo}`,
          idEmpresa: `${this.empresaValor}`,
          centroCosto: `${this.codCentroCosto}`,
          subCentroCosto: `${this.codSubCentroCosto}`,
        };

        console.log(from);

        this.axios
          .post(`VidCapacitacion/RegistrarVideosxCc`, from)
          .then((r) => {
            console.log(r.data);
            if (r.data) {
              Swal.fire({
                position: "center",
                icon: "success",
                title: "Se realizó cambios",
                showConfirmButton: false,
                timer: 1500,
              });

              
            this.listaVideos();

              const fromes = {
                vidEmpresa: `${this.empresaValor}`,
                centroCosto: `${this.codCentroCosto}`,
                subCentroCosto: `${this.codSubCentroCosto}`,
              };

              console.log(fromes);
              this.axios
                .post(`VidCapacitacion/RegistrarCapacitacionxTrab`, fromes)
                .then((r) => {
                  console.log(r.data);
                });
            }
          })
          .catch((error) => {
            console.log(error.response.data);
            Swal.fire({
              icon: "error",
              title: `${error.response.data}`,
              text: "",
              footer: "",
            });
          });
      }
    },




    listaVideos() {
      this.axios
        .get(
          `VidCapacitacion/ListarDetVideo?idEmpresa=${this.idEmpresa}&vidCc=${this.codCentroCosto}&vidScc=${this.codSubCentroCosto}`
        )
        .then((r) => {
          console.log(r.data);
          this.apiVideosAccesos = r.data;
          // this.mostrar = !this.mostrar;
          this.mostrar = true;
        });
    },
    
    

    getAttributes() {
      this.axios.get(`Empresa/EmpresaAcceso/${this.dniUsuarios}`).then((r) => {
        this.empresa = r.data;
        this.selectedSubCentroCosto = []
        console.log(r.data);
      });
    },

    CentroCostos(idEmpresa) {
      this.idEmpresa = idEmpresa;
      // const index = this.selectedEmpresas.indexOf(idEmpresa);
      // if (index === -1) {
        // Si el ID no está en el array, lo agregamos
        // this.selectedEmpresas.push(idEmpresa);
      // } else {
        // Si el ID está en el array, lo eliminamos
        // this.selectedEmpresas.splice(index, 1);
      // }

      // console.log(this.selectedEmpresas);

      // console.log(idEmpresa);
      this.empresaValor = idEmpresa;
      if (!this.array.includes(idEmpresa)) {
        this.array.push(idEmpresa);
      }
      console.log(this.array);
      this.axios
        .get(
          `Ccosto/CcxTrabajdorAcceso?idEmpresa=${idEmpresa}&dniUser=${this.dniUsuarios}`
        )
        .then((r) => {
          console.log(r.data);
          this.CentroDeCosto = r.data;
        });
    },

    SubCentroCostos(idCentro, cenCodigo) {
      this.centroCostosValor = idCentro;
      this.codCentroCosto = cenCodigo;

      const index = this.selectedCentroCosto.indexOf(cenCodigo);
      if (index === -1) {
        // Si el ID no está en el array, lo agregamos
        this.selectedCentroCosto.push(cenCodigo);
      } else {
        // Si el ID está en el array, lo eliminamos
        this.selectedCentroCosto.splice(index, 1);
      }

      console.log(this.selectedCentroCosto);

      console.log(this.arrayCentro);
      this.axios
        .get(
          `SubCentro/AccesoScxTrabajador?codCenCosto=${cenCodigo}&dniUser=${this.dniUsuarios}&idEmpresa=${this.empresaValor}`
        )
        .then((r) => {
          console.log(r.data);
          this.subCentroDeCostos = r.data;
        });
    },

    SubSubCentroCostos(id, cenCodigo) {
      console.log(id);
      this.subCentroValor = id
      this.codSubCentroCosto = cenCodigo;
      console.log(cenCodigo);

      const index = this.selectedSubCentroCosto.indexOf(cenCodigo);
      if (index === -1) {
        // Si el ID no está en el array, lo agregamos
        this.selectedSubCentroCosto.push(cenCodigo);
      } else {
        // Si el ID está en el array, lo eliminamos
        this.selectedSubCentroCosto.splice(index, 1);
      }

      if (!this.arraySubCentro.includes(cenCodigo)) {
        this.arraySubCentro.push(cenCodigo);
      }
      this.axios
        .get(
          `SubSubCentro/AccesoSscxTrabajador?idEmpresa=${this.empresaValor}&dniUser=${this.dniUsuarios}&codCentro=${this.codCentroCosto}&codSubCentro=${cenCodigo}`
        )
        .then((r) => {
          console.log(r.data);
          this.subSubCentroDeCostos = r.data;
          this.listaVideos();
          this.listaUsuarios();
        });
    },

    checkboxChanged(item) {
      console.log(`El estado del checkbox para el video ${item.idCabVideo}`);
      // Realiza aquí cualquier acción que desees hacer cuando el checkbox cambie de estado
    },
  },
};
</script>

<style scoped>
.selected {
  background-color: rgb(
    156,
    245,
    245
  ); /* Color de fondo cuando está seleccionado */
}

.tamaño {
  font-size: 0.75rem;
}
</style>
